import React from 'react'
import Client from '../homePages/Client'

const PricingClient = () => {
  return (
    <section className="pricing-clients">
    <div className="text-center pricing-main-head " data-aos='fade-down'>
      Trusted by businesses employing over 100,000 people
    </div>
    <div className="mt-5">
      <Client />
    </div>
  </section>
  )
}

export default PricingClient
